// pages/DocsPage.jsx — internal documentation landing page (admin only).
// Lists the doc topics grouped by category. Content is served by the backend
// /wiki endpoint behind require_admin.
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { authFetch } from "../api";
import "./Docs.css";

export default function DocsPage() {
  const navigate = useNavigate();
  const [index, setIndex] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    authFetch("/wiki")
      .then((data) => {
        if (data && Array.isArray(data.pages)) {
          setIndex(data);
        } else {
          setError(data?.detail || "Could not load documentation.");
        }
      })
      .catch(() => setError("Could not load documentation."));
  }, []);

  const categories = index?.categories?.length
    ? index.categories
    : [{ id: null, label: "" }];

  return (
    <>
      <Header showLogout />
      <div className="docs-shell">
        <div className="docs-wrap">
          <div className="docs-eyebrow">Internal Docs &middot; Admin</div>
          <h1>{index?.title || "Documentation"}</h1>
          <p className="docs-lead">
            {index?.subtitle ||
              "How the platform works — data, models, and pipelines."}
          </p>

          {error && <div className="docs-state">{error}</div>}
          {!index && !error && <div className="docs-state">Loading…</div>}

          {index &&
            categories.map((cat) => {
              const pages = index.pages.filter(
                (p) => (p.category || null) === (cat.id || null)
              );
              if (!pages.length) return null;
              return (
                <section className="docs-cat" key={cat.id || "uncat"}>
                  {cat.label && <div className="docs-cat-label">{cat.label}</div>}
                  <div className="docs-grid">
                    {pages.map((p) => (
                      <button
                        key={p.slug}
                        className="doc-card"
                        onClick={() => navigate(`/docs/${p.slug}`)}
                      >
                        <div className="doc-card-top">
                          {p.icon && (
                            <span className="doc-card-icon">{p.icon}</span>
                          )}
                          <span className="doc-card-title">{p.title}</span>
                        </div>
                        <p className="doc-card-desc">{p.description}</p>
                      </button>
                    ))}
                  </div>
                </section>
              );
            })}
        </div>
      </div>
    </>
  );
}
